
import doctorCard from '@/components/clinic/doctorItem.vue'
import tabSelect from '@/components/clinic/oldTabSelect.vue'
import InfiniteLoading from 'vue-infinite-loading';
import LoadMore from 'vux/src/components/load-more/index.vue'

import noOrder from '@/components/normal/noData/noOrder'
import oasis from '../../lib/api.oasis'
import native from '../../lib/native'
import { workAgeCalc, doctorProf } from '../../lib/correspondence.js'
export default {
props: [''],
data () {
return {
AnCan:[],
deptId:'',
names:'',
keNames:"",
cityCode:'',
doctors: [],
pageNum: 1,
newPosition:'',
district:'',
loading:false
}
},
components: {
tabSelect,
doctorCard,
InfiniteLoading,
LoadMore,
noOrder
},
methods: {
goDetail(data){
var origin=location.origin
native.openwebview(JSON.stringify({
linkurl:`${origin}/clinic/doctorDetail/${data}`,
ifNavigation:'1',
tipsTopNav:'1',
isRefresh:'1'
}));
},
getDataLists(params){
this.AnCan=params

if(this.AnCan.address.area==''){//点击的为热门城市
this.cityCode=this.AnCan.address.hodCity.areacode
}
else{//点击的为具体城市
if(this.AnCan.address.area.areacode==''){//具体区的code为0
this.cityCode=this.AnCan.address.city.areacode
this.district=''
}else{//具体区的code不为0
this.cityCode=this.AnCan.address.city.areacode
this.district=this.AnCan.address.area.areacode
}
}

if(this.AnCan.subject.child){
if(this.AnCan.subject.child.deptId==''){//进入科室后点到全部的情况 全部deptId为空
this.deptId=this.AnCan.subject.deptId
}else{
this.deptId=this.AnCan.subject.child.deptId
}
}
this.pageNum=1
this.$router.replace(this.$route.path)
this.doctors = []
this.$nextTick(() => {
this.$refs.load.$emit("$InfiniteLoading:reset");
});
},
doctorList ($state) {
let info =  {
"latitude":'',
"longitude":'',
"pagenum":this.pageNum,
"pagesize":"10",
"citycode":this.cityCode||this.newPosition.cityCode,
"deptid":this.deptId,
"district":this.district||''
}
console.log(info, 'info')
let that = this
oasis.postDoctorList(info).then(response => {
console.log(response.datalist,'----response.datalist-----')
if (response.datalist && response.datalist.length) {
let doctors = response.datalist,
tempArr = []
doctors.forEach(function (item, index, arr) {
let obj = {}
obj.name = item.doctorname
obj.imgPath = item.head
obj.deptName = item.deptname
obj.professional = doctorProf[item.prof]
obj.workAge = workAgeCalc(item.workyear)
obj.hospital = item.hospital
obj.goodAtValue = item.expertise

obj.attitude = item.attitudetype

obj.effect = item.medeffect
obj.doctorIdStr=item.doctorid
obj.doctorServiceList=item.doctorServiceList
tempArr.push(obj)
})
that.doctors = that.doctors.concat(tempArr)
$state.loaded()
that.pageNum++
if (doctors.length<info.pagesize) {
$state.complete()
}
} else {
$state.complete()
}
}).catch(error => {
console.log(error)
})
},
cityInfo () {

let info = {}
oasis.postCityInfo(info).then(response => {
console.log(response)
}).catch(error => {
console.log(error)
})
},
},
mounted () {
native.getPosition().then(position=>{
this.newPosition=position,
this.loading=true
})

}
}



// WEBPACK FOOTER //
// ./src/views/clinic/doctorList.vue